{
    "Quantity": "Quantidade",
    "Item": "Item",
    "CMEnvironment": "CMEs",
    "TelephonyServer": "Servidor de telefonia",
    "Partitions": "Partições",
    "Devices": "Dispositivos",
    "Agents": "Agentes",
    "ReportingUsers": "Denunciar usuários",
    "NonReportingUsers": "Usuários que não relatam",
    "Estate_ButtonHelpLabel": "Ajuda?",
    "Estate_ButtonSubmitLabel": "OK",
    "Estate_ButtonCancelLabel": "Cancelar",
    "Estate_PromptMessage": "Tem certeza de que deseja fechar esta janela? Todas as configurações modificadas serão perdidas quando fechadas.",
    "Estate_PromptConfirm": "sim",
    "Estate_PromptCancel": "Cancelar",
    "NAME": "Estate"
}